import { render, staticRenderFns } from "./onlinePay.vue?vue&type=template&id=345f880a&scoped=true&"
import script from "./onlinePay.vue?vue&type=script&lang=js&"
export * from "./onlinePay.vue?vue&type=script&lang=js&"
import style0 from "./onlinePay.vue?vue&type=style&index=0&id=345f880a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345f880a",
  null
  
)

export default component.exports